import { render, staticRenderFns } from "./NotificationSlide.vue?vue&type=template&id=7cdb4e08&scoped=true&"
import script from "./NotificationSlide.vue?vue&type=script&lang=js&"
export * from "./NotificationSlide.vue?vue&type=script&lang=js&"
import style0 from "./NotificationSlide.vue?vue&type=style&index=0&id=7cdb4e08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cdb4e08",
  null
  
)

export default component.exports